import { query, utils, helpers } from '@kurtosys/ksys-app-template';
import { IQueryKeyValue, IFundManager } from '../../../models/commonTypes';
import { AppStoreBase } from './AppStoreBase';
import { IAppComponents } from '../models/IAppComponents';
import { computed } from 'mobx';
import { StoreContext } from '../../../configuration/StoreContext';
import { ICardProps } from '@kurtosys/ksys-app-components/dist/components/base/Card/models';
import { Manifest } from '../../../configuration/Manifest';
import { ICarouselProps } from '@kurtosys/ksys-app-components/dist/components/base/Carousel/models';
import { IConfigurationRedirect } from '../../../models/app/IConfigurationRedirect';
import { IFundManagerCardProps } from '../../FundManagerCard/models/IFundManagerCardProps';
import { FundManagerCardStore } from '../../FundManagerCard/stores/FundManagerCardStore';

/* [Component: appStoreComponentImport] */

export class AppStore extends AppStoreBase {
	redirectHelper: helpers.RedirectHelper;

	constructor(element: HTMLElement, url: string, storeContext: StoreContext, manifest: Manifest) {
		super(element, url, storeContext, manifest);
		this.redirectHelper = new helpers.RedirectHelper(url);
	}

	@computed
	get hasData(): boolean {
		return Array.isArray(this.fundManagerCards) && this.fundManagerCards.length > 0;
	}

	@computed
	get components(): IAppComponents {
		return {
			/* [Component: appStoreComponent] */
		};
	}

	@computed
	get defaultPhoto(): string {
		const defaultPhoto = this.appComponentConfiguration && this.appComponentConfiguration.defaultPhoto;
		return defaultPhoto || '';
	}

	@computed
	get carouselProps(): ICarouselProps | undefined {
		return this.appComponentConfiguration && this.appComponentConfiguration.carouselProps;
	}

	@computed
	get fundManagerCards(): IFundManagerCardProps[] {
		const fundManagersQuery = this.appComponentConfiguration && this.appComponentConfiguration.fundManagers;
		const fundManagers = this.getQueryValue(fundManagersQuery) || [];
		return fundManagers.map((fundManager: any) => {
			return {
				fundManagerCardStore: new FundManagerCardStore(this.storeContext, fundManager),
			};
		});
	}

	getRedirectUrl(redirectConfiguration: IConfigurationRedirect): string {
		const { queryStore } = this.storeContext;
		const { redirect, inputs: redirectInputs } = redirectConfiguration;

		const inputQueriesByKey = redirectInputs.reduce((redirectConfigInputs, inputConfig) => {
			if (!redirectConfigInputs[inputConfig.key]) {
				redirectConfigInputs[inputConfig.key] = inputConfig.query;
			}
			return redirectConfigInputs;
		}, {} as IQueryKeyValue);

		const inputs = query.Query.convertQueryKeyValue(inputQueriesByKey, queryStore.executionOptions);
		return this.redirectHelper.getRedirectPath(redirect, inputs);
	}

	@computed
	get baseServiceUrl(): string {
		const { kurtosysApiStore } = this.storeContext;
		return kurtosysApiStore.getBaseAddress();
	}

	@computed
	get cardProps(): ICardProps | undefined {
		const cardProps = this.appComponentConfiguration && this.appComponentConfiguration.cardProps;
		return this.mergeQueriesAndProps(cardProps);
	}
}
